import { loadingInterceptor } from './@core/interceptor/loading.interceptor';
import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
  importProvidersFrom, isDevMode,
  APP_INITIALIZER,
  provideAppInitializer,
  inject,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router'; // Provides RouterModule
import { routes } from './app.routes'; // Your routing configuration
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from '@core/interceptor/auth-interceptor';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideServiceWorker } from '@angular/service-worker';
import { errorHandlerInterceptor } from '@core/interceptor/error-handler.interceptor';
// import { AuthService } from '@core/services/auth';
// import { EP } from '@core/config';
// export function initMaintenance(service: AuthService) {
//   return () => service.loadStatus(EP.Public);
// }
export const appConfig: ApplicationConfig = {
  providers: [
    
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes, withInMemoryScrolling({
        scrollPositionRestoration: 'top', // 👈 scroll to top on navigation
        anchorScrolling: 'enabled'
      })), // Use the router provided with routes
    provideHttpClient(
      withInterceptors([
        // loadingInterceptor,
        authInterceptor,
        errorHandlerInterceptor,
      ])
    ),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'en',
      })
    ),
    ...provideTranslateHttpLoader({
      prefix: './assets/i18n/',
      suffix: '.json',
      enforceLoading: false,
      useHttpBackend: false,
    }),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    // provideAppInitializer(() => {
    //   const authService = inject(AuthService);
    //   return authService.loadStatus(EP.Public);
    // })
  ],
};
